import { useState, useEffect } from 'react';
import moment from 'moment';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import { getFormatedTimeString } from '../Helper/utils';
import { dayNames } from "../constant"
import { SlotsSplitView } from "./SlotsSplitView"
const DayWise = ({day, data})=>{
    const durationSize = data?.length;
    const startTime = data[0].startTime ;
    const endTime =data[durationSize-1].endTime ;
    const totalSlots = data.reduce((acc, obj) => acc + obj.slots, 0);
    ;
    return (<>
        <div className="flex flex-col">
            <p className="font-medium text-[#252D38]">
            {dayNames[day]}
            </p>
            <p className="font-normal text-sm ">
            {getFormatedTimeString(startTime)} to {getFormatedTimeString(endTime)}
            </p>
            <p> {totalSlots} slots </p>
        </div>
    </>);
}


function EnhancedTableHead() {
  const tableHeaderList = [
    {
      id: 'slots',
      disablePadding: false,
      label: 'SLOTS AS SHOWN TO CUSTOMERS',
    },
  ];
  return (
    <TableHead>
      <TableRow className='flex flex-row'>
        <TableCell
          key={'Day'}
          align={'left'}
          padding={'normal'}
          className={'bg-gray-100 flex-1  px-6 py-3 '}
          sx={{ width: '4.25rem', 
            minHeight: '1.25rem', 
            'color': '#596C86', 
            'fontSize': '14px', 
            'font-weight': 600, 
            border: '1px solid #ddd', 
            background:"#F3F4F6",
            padding: '24 14',  }}
        >
          DAY-WISE SUMMARY
        </TableCell>

        {tableHeaderList.map((headCell) => (
          <>
            <TableCell
              key={headCell.id}
              align={'left'}
              padding={'normal'}
              className={'bg-gray-100  flex-5 '}
              sx={{ 
                width: '23.2rem', 
                minHeight: '1.25rem', 
                'color': '#596C86', 'fontSize': '14px', 
                'font-weight': 600, 
                background:"#F3F4F6",
                border: '1px solid #ddd', }}
            >
              <div className="flex justify-center align-center">
                {headCell.label}
              </div>
            </TableCell>
          </>

        ))}
      </TableRow>
    </TableHead>
  );
}



export const SlotsPreviewTable = ({ doctorSlots }) => {
  const [slots, setSlots] = useState({})

  useEffect(() => {
    
    const transformDoctorSlots = (doctorSlotsNew) => {
        const groupedSlots = doctorSlotsNew?.reduce((acc, slot) => {
          const day = slot.dayOfWeek;
          if (!acc[day]) {
            acc[day] = [];
          }
          acc[day].push(slot);
          return acc;
        }, {});
        for (const day in groupedSlots) {
          groupedSlots[day].sort((a, b) => a.startTime - b.startTime);
        }
        return groupedSlots;
    }
    const formatedDoctorSlots = transformDoctorSlots(doctorSlots || []);
    setSlots(formatedDoctorSlots);
  }, [doctorSlots])

  return (
    <>
    <div className="flex-1 overflow-y-auto rounded-xl">
      <Box sx={{ width: '100%', overflow:'scroll', }} className=''>
        <Paper sx={{ width: '100%',  }}>
          <TableContainer sx={{  border:"2px solid #ddd", borderRadius:"0.5rem", maxHeight:'60vh', width:'100%' }}>
            <Table
              aria-labelledby="tableTitle"
              size={'medium'}
              stickyHeader
>
              <EnhancedTableHead />

              {slots && Object.entries(slots).map(([day, data], index) => (
                <TableRow
                  tabIndex={-1}
                  sx={{ cursor: 'pointer' }}
                >
                  <TableCell
                    align="left"
                    component="th"
                    scope="row"
                    padding="normal"
                    className={"flex gap-2 justify-center border-x- "}
                    sx={{
                      borderBottom: '5px solid #ddd',
                      borderRight: '1px solid #ddd',
                      borderLeft: '1px solid #ddd',
                      color: "#596C86",
                    }}
                  >
                    <div className="flex justify-start align-center text-[#47566A]">
                   < DayWise day={day} data={data} />
                    </div>
                  </TableCell>
                  {(
                    <>
                          <TableCell sx={{  
                            borderBottom: '4px solid #ddd',
                            borderRight: '1px solid #ddd',
                            padding:'0',
                            alignContent:'start',
                            justifyContent:'start',
                             }}>
                              <SlotsSplitView slots={data}/>
                          </TableCell>
                    </>
                  )}

                </TableRow>
              ))}
            </Table>
          </TableContainer>
        </Paper>
      </Box>
      </div>
    </>

  );
}